module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title-acknowPage"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Grateful thanks are due to all those who helped in any way with this book and particularly the following: Amanda Bennett and the staff at the Priaulx Library in St Peter Port; Stephen Collas at the Guille Allès Library in St Peter Port; Alderney Museum; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Guernsey Press")]), _vm._v(", especially Di Digard for her unfailing encouragement and sense of humour; States Archive Service in St Peter Port; Rupert Harding of Pen & Sword Publishing for his help and support; Citizens Advice Bureau.")])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d65798a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408269_ack01.vue
// module id = 72
// module chunks = 0